// import { Button } from "@workspace/web-ui/components/button";
import { Button } from "@workspace/web-ui/components/button";
import { Separator } from "@workspace/web-ui/components/separator";


type EmptyStateCardProps = {
  title: string;
  description?:string;
  message: string;
  image: string;
  altImg: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
};

const EmptyMedicalCard: React.FC<EmptyStateCardProps> = ({
  title,
  message,
  image,
  altImg,
  description,
  buttonText,
  onButtonClick,
  showButton
}) => {
  return (
    <div className="border rounded-xl shadow-sm bg-white w-full text-center mb-4 ">
      <h3 className="text-lg font-medium text-left p-5">{title}</h3>
      <Separator />
      <div className="flex flex-col items-center justify-center py-10">
        <img src={image} alt={altImg} className="size-14 mb-1"/>
        <h4 className="text-lg py-2 font-medium">{description}</h4>
        <p className="text-base text-gray-500 max-w-md">{message}</p>
        {showButton && buttonText && onButtonClick && (
          <Button className="mt-5 bg-[#4272DD] px-4 py-1 rounded-lg" onClick={onButtonClick}>
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyMedicalCard;